import React from 'react';
import { Asset } from '../../../queries/ats/titles/types/asset';
import { Source } from '../../../queries/ats/titles/types/sources';
import { FocusedAsset } from '../use-focused-asset';
import { SvodCallToAction } from './svod-call-to-action';
import { ThirdPartyCallToAction } from './third-party-call-to-action';
import { ProgramCallToAction } from './program-call-to-action/program-call-to-action';
import { VodCallToAction } from './vod-call-to-action';
import { CallToAction } from './call-to-action-button';
import { getPreferredRecording } from '../../../queries/ats/titles/utils/recording-utils';
import { RecordedCallToAction } from './program-call-to-action/recorded-call-to-action';

export interface DetailsCallToActionProps {
  asset: Asset;
  focusedAsset: FocusedAsset;
  source: Source;
}

export function DetailsCallToAction({ asset, focusedAsset, source }: DetailsCallToActionProps) {
  switch (source.type) {
    case 'program':
      const recording = getPreferredRecording(source, true);
      return recording !== undefined && recording.status === 'completed' ? (
        <RecordedCallToAction focusedAsset={focusedAsset} recording={recording} image={source.image} />
      ) : (
        <ProgramCallToAction focusedAsset={focusedAsset} source={source} />
      );
    case 'thirdparty':
      return <ThirdPartyCallToAction asset={asset} source={source} />;
    case 'svod':
      return <SvodCallToAction asset={asset} focusedAsset={focusedAsset} source={source} />;
    case 'vod':
      return <VodCallToAction asset={asset} focusedAsset={focusedAsset} source={source} />;
    default:
      throw new Error(`Provider type "never" not supported`);
  }
}

export function DetailsCallToActionSkeleton() {
  return <CallToAction.Skeleton />;
}

DetailsCallToAction.Skeleton = DetailsCallToActionSkeleton;
